if (!customElements.get('component-convert-price')) {
class ComponentConvertPrice extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const basePriceCents = this.getBasePriceCents();
    const baseCurrency = this.getBaseCurrency();
    const moneyFormat = this.getMoneyFormat();
    
    
    if (!basePriceCents) {
      return;
    }
    
    const convertedPriceCents = this.convertPrice(basePriceCents, baseCurrency);
    this.renderPrice(convertedPriceCents, moneyFormat);
  }

  getBasePriceCents() {
    return parseFloat(this.getAttribute('base-price') || '37000');
  }

  getBaseCurrency() {
    return this.getAttribute('base-currency') || 'USD';
  }

  getMoneyFormat() {
    return this.getAttribute('money-format') || '${{amount_no_decimals}}';
  }

  getCurrencyData() {
    return window.Shopify?.currency || { 
      active: this.getBaseCurrency(), 
      rate: '1.0' 
    };
  }

  convertPrice(basePriceCents, baseCurrency) {
    const { active: currentCurrency, rate: currentRate } = this.getCurrencyData();
    
    if (baseCurrency === currentCurrency) {
      return basePriceCents;
    }
    
    const basePrice = basePriceCents / 100;
    const convertedPrice = basePrice * parseFloat(currentRate);
    const roundedPrice = Math.ceil(convertedPrice);
    
    return roundedPrice * 100;
  }

  formatPrice(priceCents, moneyFormat) {
    setTimeout(() => {
     

    if (window.formatMoney) {
      return window.formatMoney(priceCents, moneyFormat);
    }
    
    const { active: currency } = this.getCurrencyData();
    return `${priceCents / 100} ${currency}`;

  }, 0);
  }

  cleanFormattedPrice(formattedPrice) {
    return formattedPrice
      .replace(/,/g, '')
      .replace(/\./g, '')
      .replace('Dhs', 'Dhs.');
  }

  renderPrice(priceCents, moneyFormat) {
    const formatted = this.formatPrice(priceCents, moneyFormat);
    this.innerHTML = this.cleanFormattedPrice(formatted);
  }
}


  customElements.define('component-convert-price', ComponentConvertPrice);
}
 